<template>
    <div class="form">
        <h3 class="mb-5 text-primary" v-if="nomeEvento">{{ nomeEvento }}</h3>

        <validation-observer ref="forms" v-slot="{handleSubmit}">
            <form class="form-group" @submit.prevent="handleSubmit(submitParticipante)">
                <div class="grid-1 form-2">
                    <validation-provider name="CPF" vid="cpf" rules="required" v-slot="{errors}"
                                         tag="div" class="input-std form-text">
                        <label>CPF</label>
                        <input type="text" @change="validarCPF()" placeholder="CPF do participante"
                               v-model="form.cpf" v-mask="'###.###.###-##'" class="input-size"/>
                        <p class="errors">{{ errors[0] }}</p>
                    </validation-provider>

                    <validation-provider name="Nome" vid="nome" rules="required" v-slot="{errors}"
                                         tag="div" class="input-std form-text">
                        <label>Nome Completo</label>
                        <input type="text" placeholder="Nome do participante"
                               v-model="form.nome_completo"/>
                        <p class="errors">{{ errors[0] }}</p>
                    </validation-provider>

                    <validation-provider name="Cargo" vid="cargo" rules="required" v-slot="{errors}"
                                         tag="div" class="input-std form-text">
                        <label>Cargo</label>
                        <input type="text" placeholder="Cargo do participante"
                               v-model="form.cargo"/>
                        <p class="errors">{{ errors[0] }}</p>
                    </validation-provider>

                    <validation-provider name="Tipo" vid="tipo" rules="required" v-slot="{errors}"
                                         tag="div" class="input-std form-text">
                        <label><strong>Tipo de participação</strong></label>
                        <select v-model="form.tipo" style="background-color:red; border-color:red; color:white; font-weight: bold">
                            <option value=""></option>
                            <option value="1" v-if="tipo_evento == 1 || tipo_evento == 3">Presencial</option>
                            <option value="2" v-if="tipo_evento == 2 || tipo_evento == 3">Online</option>
                        </select>
                        <p class="errors">{{ errors[0] }}</p>
                    </validation-provider>
                </div>

                <div class="grid-1 form-2">
                    <validation-provider name="Email" vid="email" rules="required|email"
                                         v-slot="{errors}" tag="div" class="input-std form-text">
                        <label>Email do Representante</label>
                        <input type="text" placeholder="Email do participante"
                               v-model="form.email"/>
                        <p class="errors">{{ errors[0] }}</p>
                    </validation-provider>

                    <validation-provider name="Telefone Fixo" vid="celular" rules="required"
                                         v-slot="{errors}" tag="div" class="input-std form-text">
                        <label>Telefone fixo</label>
                        <input type="text" v-model="form.telefone" placeholder="Telefone fixo"
                               v-mask="'(##) ####-####'"/>
                        <p class="errors">{{ errors[0] }}</p>
                    </validation-provider>

                    <validation-provider name="Celular" vid="celular" rules="required"
                                         v-slot="{errors}" tag="div" class="input-std form-text">
                        <label>Celular</label>
                        <input type="text" placeholder="Celular" v-model="form.celular"
                               v-mask="'(##) #####-####'"/>
                        <p class="errors">{{ errors[0] }}</p>
                    </validation-provider>

                    <validation-provider name="Whatsapp" vid="whatsapp" rules="required"
                                         v-slot="{errors}" tag="div" class="input-std form-text">
                        <label>Whatsapp</label>
                        <input type="text" placeholder="Whatsapp" v-model="form.whatsapp"
                               v-mask="'(##) #####-####'"/>
                        <p class="errors">{{ errors[0] }}</p>
                    </validation-provider>
                </div>

                <div class="grid-2" v-if="$store.getters['user/getUser'].sindicato_id === 0">
                    <validation-provider
                        name="Sindicato"
                        vid="sindicato"
                        rules="required"
                        v-slot="{errors}"
                        tag="div"
                        class="input-std form-text">
                        <label>Sindicato</label>
                        <select v-model="form.sindicato_id" class="text-black">
                            <option value="" disabled></option>
                            <option v-for="(sindicato, index) in sindicatos" :key="index"
                                    :value="sindicato.id">
                                {{ sindicato.nome_fantasia }}
                            </option>
                        </select>
                        <p class="errors">{{ errors[0] }}</p>
                    </validation-provider>


                </div>

                <h3 class="card-header">Endereço do Participante</h3>

                <div class="grid-1 form-3">
                    <validation-provider name="Cep" vid="cep" rules="required" v-slot="{errors}"
                                         tag="div" class="input-std form-text">
                        <label>CEP</label>
                        <input type="text" placeholder="CEP do participante" v-model="form.cep"
                               @blur="buscaCep" v-mask="'#####-###'" maxlength="9"/>
                        <p class="errors">{{ errors[0] }}</p>
                    </validation-provider>

                    <validation-provider name="Endereço" vid="nome" rules="required"
                                         v-slot="{errors}" tag="div" class="input-std form-text">
                        <label>Endereço</label>
                        <input type="text" placeholder="Endereço do participante"
                               v-model="form.endereco"/>
                        <p class="errors">{{ errors[0] }}</p>
                    </validation-provider>

                    <validation-provider name="Número" vid="numero" rules="required"
                                         v-slot="{errors}" tag="div" class="input-std form-text">
                        <label>Numero</label>
                        <input type="text" placeholder="Número" v-model="form.nro"/>
                        <p class="errors">{{ errors[0] }}</p>
                    </validation-provider>

                    <validation-provider name="Bairro" vid="bairro" rules="required"
                                         v-slot="{errors}" tag="div" class="input-std form-text">
                        <label>Bairro</label>
                        <input type="text" placeholder="Bairro do participante"
                               v-model="form.bairro"/>
                        <p class="errors">{{ errors[0] }}</p>
                    </validation-provider>
                </div>

                <div class="grid-2">
                    <validation-provider name="Cidade" vid="cidade" rules="required"
                                         v-slot="{errors}" tag="div" class="input-std form-text">
                        <label>Cidade</label>
                        <input type="text" placeholder="Cidade do participante"
                               v-model="form.cidade"/>
                        <p class="errors">{{ errors[0] }}</p>
                    </validation-provider>

                    <validation-provider name="Estado" vid="estado" rules="required"
                                         v-slot="{errors}" tag="div" class="input-std form-text">
                        <label>UF</label>
                        <input type="text" placeholder="UF" v-model="form.estado"/>
                        <p class="errors">{{ errors[0] }}</p>
                    </validation-provider>
                </div>

                <div class="flex justify-end">
                    <button class="btn btn-primary">
                        {{ (form.id) ? 'Atualizar Participante' : 'Salvar Participante' }}
                    </button>
                </div>
            </form>
        </validation-observer>
    </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import 'flatpickr/dist/themes/airbnb.css'
import {mask} from "vue-the-mask"

const Brasil = require('flatpickr/dist/l10n/pt.js').default.pt
export default {
    name: 'form-evento',

    components: {
        flatPickr
    },

    directives: {mask},

    created() {
        this.getSindicatos()
        this.getEvento()
        this.popularParticipante()
    },

    mounted() {
        this.form.evento_id = this.$route.params.id
    },

    data() {
        return {
            sindicatos: [],
            nomeEvento: '',
            tipo_evento: '',
            form: {
                id: null,
                cpf: '',
                nome_completo: '',
                cep: '',
                endereco: '',
                nro: '',
                bairro: '',
                cidade: '',
                estado: '',
                cargo: '',
                email: '',
                telefone: '',
                celular: '',
                whatsapp: '',
                sindicato_id: '',
                evento_id: '',
                tipo: '',
            },
        }
    },

    methods: {
        validarCPF() {
            if (this.validadorDeCPF((this.form.cpf))) {
                this.buscarCPF();
            } else {
                this.$swal({
                    title: 'Ops!',
                    text: 'Você digitou um CPF inválido, por favor, verifique o número informado.',
                    icon: 'error',
                })
                this.form.id = null;
                this.form.cpf = '';
                this.form.nome_completo = '';
                this.form.cargo = '';
                this.form.email = '';
                this.form.telefone = '';
                this.form.celular = '';
                this.form.whatsapp = '';
                this.form.cep = '';
                this.form.endereco = '';
                this.form.nro = '';
                this.form.bairro = '';
                this.form.cidade = '';
                this.form.estado = '';
                this.form.tipo = 0;
                this.form.sindicato_id = null;

            }
        },

        buscarCPF() {
            if (this.form.cpf.length === 14) {
                this.axios.get('inscritos-cpf/' + this.form.cpf).then(response => {
                    if (response.data.inscrito !== null) {
                        this.form.id = response.data.inscrito.id;
                        this.form.nome_completo = response.data.inscrito.nome_completo;
                        this.form.cargo = response.data.inscrito.cargo;
                        this.form.email = response.data.inscrito.email;
                        this.form.telefone = response.data.inscrito.telefone;
                        this.form.celular = response.data.inscrito.celular;
                        this.form.whatsapp = response.data.inscrito.whatsapp;
                        this.form.cep = response.data.inscrito.cep;
                        this.form.endereco = response.data.inscrito.endereco;
                        this.form.nro = response.data.inscrito.nro;
                        this.form.bairro = response.data.inscrito.bairro;
                        this.form.cidade = response.data.inscrito.cidade;
                        this.form.estado = response.data.inscrito.estado;
                    }
                }).catch(error => {
                    console.error(error)
                });
            }
        },

        validadorDeCPF(cpf) {
            //VERIFICO SE O CPF PASSADO NÃO ESTÁ VAZIO
            if (cpf === null)
                return false;
            //LIMPO OS CARACTERES INVÁLIDOS DO CPF
            cpf = cpf.replace(/[^\d]+/g, '');
            //VERIFICO SE ELE NÃO TEM 11 DIGITOS OU É UMA SEQUENCIA NUMÉRICA
            if (cpf.length !== 11 || cpf === "00000000000" || cpf === "11111111111" || cpf === "22222222222" || cpf === "33333333333" ||
                cpf === "44444444444" || cpf === "55555555555" || cpf === "66666666666" || cpf === "77777777777" || cpf === "88888888888" ||
                cpf === "99999999999")
                return false;
            //VALIDO O 1º DIGITO VERIFICADOR
            let dgUm = 0;
            for (let i = 0; i < 9; i++)
                dgUm += parseInt(cpf.charAt(i)) * (10 - i);
            let revUm = 11 - (dgUm % 11);
            if (revUm === 10 || revUm === 11)
                revUm = 0;
            if (revUm !== parseInt(cpf.charAt(9)))
                return false;
            //VALIDO O 2º DIGITO VERIFICADOR
            let dgDois = 0;
            for (let i = 0; i < 10; i++)
                dgDois += parseInt(cpf.charAt(i)) * (11 - i);
            let revDois = 11 - (dgDois % 11);
            if (revDois === 10 || revDois === 11)
                revDois = 0;
            if (revDois !== parseInt(cpf.charAt(10)))
                return false;

            //RETORNO TRUE SE PASSOU POR TODAS AS VALIDAÇÕES
            return true;
        },

        async popularParticipante() {
            if (this.$route.params.participante_id) {
                let participante = await this.getParticipante(this.$route.params.participante_id)
                for (var key in participante) {
                    this.form[key] = participante[key]
                }
            }
        },

        async getParticipante(id) {
            let result = await this.axios('participantes/' + id)
            return result.data.participante
        },

        buscaCep() {
            let cep = this.form.cep.replace('-', '')
            if (cep.length === 8) {
                this.axios.get('https://viacep.com.br/ws/' + cep + '/json/', {baseURL: 'viacep.com.br'}).then(response => {
                    this.form.endereco = response.data.logradouro
                    this.form.bairro = response.data.bairro
                    this.form.cidade = response.data.localidade
                    this.form.numero = ''
                    this.$store.commit('loadingScreen/setLoading', false);
                }).catch(error => {
                    this.$store.commit('loadingScreen/setLoading', false);
                    this.form.endereco = ''
                    this.form.bairro = ''
                    this.form.cidade = ''
                    this.form.numero = ''
                    console.error(error)
                })
            } else {
                this.form.endereco = ''
                this.form.bairro = ''
                this.form.cidade = ''
                this.form.numero = ''
            }
        },

        getSindicatos() {
            this.axios('get-all-sindicatos')
                .then(response => {
                    this.sindicatos = response.data.sindicato
                })
        },

        getEvento() {
            this.axios('eventos/' + this.$route.params.id)
                .then(response => {
                    this.nomeEvento = response.data.evento.nome;
                    this.tipo_evento = response.data.evento.tipo_evento;
                })
        },

        async submitParticipante() {
            if (this.$store.getters['user/getUser'].sindicato_id !== 0) {
                console.log('teste')
                this.form.sindicato_id = this.$store.getters['user/getUser'].sindicato_id;
            }
            let response = await this.axios.post('participantes', this.form)
            if (response.status === 200) {
                this.axios.post('inscritos', this.form).then(res => {
                    this.$swal({
                        title: 'Sucesso',
                        text: (this.form.id) ? 'O participante foi atualizado com sucesso' : 'O participante foi criado com sucesso',
                        icon: 'success',
                    })
                    this.$router.push('/sistema/eventos/lista-eventos')
                }).catch(error => {
                    this.$swal({
                        title: 'Ops!',
                        text: error.response.data.message,
                        icon: 'error',
                    })
                })
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.form-1 {
    @media(min-width: 640px) {
        @apply grid-cols-3;
    }
}

.form-2 {
    @media(min-width: 640px) {
        @apply grid-cols-2;
    }
    @media(min-width: 1024px) {
        @apply grid-cols-4;
    }
}

.form-3 {
    @media(min-width: 640px) {
        @apply grid-cols-2;
    }
    @media(min-width: 1024px) {
        @apply grid-cols-4;
    }
}
</style>
